/* @flow */

import api from './fetch'

export const getBulkJob = (bulkJobId, options) =>
  api.get(`/bulk-jobs/${bulkJobId}`, {
    query: options,
  })
